import * as Comp from './switch-toggle.styles'
export const SwitchToggle = () => {
  return <Comp.Toggle />
}
